import React from 'react';
import { ArrowRight, FolderOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import useServiceCategories from '../data/useServiceCategories';
import './ServiceCategoriesPage.css';

export default function ServiceCategoriesPage() {
  const { language, localizeCategory } = useLanguage();
  const categories = useServiceCategories();

  const text = language === 'zh' ? {
    kicker: '服务目录',
    title: '按分类找到合适的技能服务',
    subtitle: '浏览服务范围和子类目，再进入服务列表比较价格、交付方式与评价。',
    serviceCount: count => `${count} 项已发布服务`,
    browse: '浏览服务',
    empty: '暂时没有可用服务分类。',
  } : {
    kicker: 'Service catalogue',
    title: 'Find the right service by category',
    subtitle: 'Review service areas and subcategories, then compare scope, delivery, pricing, and reviews.',
    serviceCount: count => `${count} published services`,
    browse: 'Browse services',
    empty: 'No service categories are available yet.',
  };

  return (
    <div className="service-categories-page">
      <div className="container service-categories-shell">
        <header className="service-categories-header">
          <div>
            <span className="service-categories-kicker">{text.kicker}</span>
            <h1>{text.title}</h1>
            <p>{text.subtitle}</p>
          </div>
          <Link className="btn btn-outline" to="/services">{text.browse}<ArrowRight size={16} /></Link>
        </header>

        {categories.length === 0 ? (
          <div className="service-categories-empty">{text.empty}</div>
        ) : (
          <section className="service-categories-grid" aria-label={text.kicker}>
            {categories.map((category, index) => (
              <article className={`service-category-card service-category-tone-${index % 6}`} key={category.id || category.name}>
                <div className="service-category-card-head">
                  <span className="service-category-icon" aria-hidden="true">
                    {category.icon || <FolderOpen size={21} />}
                  </span>
                  <span className="service-category-count">{text.serviceCount(category.service_count || 0)}</span>
                </div>
                <h2>{localizeCategory(category.name)}</h2>
                {category.description && <p>{category.description}</p>}
                <div className="service-category-items">
                  {(category.items || []).map(item => <span key={item}>{item}</span>)}
                </div>
                <Link to={`/services?categories=${encodeURIComponent(category.name)}`} className="service-category-link">
                  {text.browse}<ArrowRight size={15} />
                </Link>
              </article>
            ))}
          </section>
        )}
      </div>
    </div>
  );
}
